import { lazy } from "react";

const BookingRoomPage = lazy(() => import("./main"));

export { BookingRoomPage };
